// extracted by mini-css-extract-plugin
module.exports = {"CountdownContainer":"CountDown_CountdownContainer__3StRZ","TimerValue":"CountDown_TimerValue__3o8Fh"};